export const cssVar = (str: string | undefined) => (str ? `var(${str})` : '');
